import React, { useEffect, useState } from 'react';
import { ShoppingBag, X } from 'lucide-react';
const SALES = [{
  name: 'Mariana G.',
  city: 'Buenos Aires',
  time: 'hace 2 minutos'
}, {
  name: 'Claudia R.',
  city: 'Córdoba',
  time: 'hace 5 minutos'
}, {
  name: 'Valeria M.',
  city: 'Rosario',
  time: 'hace 8 minutos'
}, {
  name: 'Patricia L.',
  city: 'Mendoza',
  time: 'hace 11 minutos'
}, {
  name: 'Silvina T.',
  city: 'La Plata',
  time: 'hace 14 minutos'
}, {
  name: 'Andrea F.',
  city: 'Mar del Plata',
  time: 'hace 18 minutos'
}, {
  name: 'Graciela P.',
  city: 'Tucumán',
  time: 'hace 22 minutos'
}, {
  name: 'Mónica S.',
  city: 'Salta',
  time: 'hace 27 minutos'
}, {
  name: 'Daniela H.',
  city: 'San Juan',
  time: 'hace 31 minutos'
}, {
  name: 'Roxana V.',
  city: 'Neuquén',
  time: 'hace 35 minutos'
}];
export function SaleNotification() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);
  const showNext = (index: number) => {
    setCurrent(index);
    setAnimating(true);
    setVisible(true);
    // Auto-hide after 5 seconds
    setTimeout(() => {
      setAnimating(false);
      setTimeout(() => setVisible(false), 400);
    }, 5000);
  };
  useEffect(() => {
    // Show first notification after 4 seconds
    const initial = setTimeout(() => {
      showNext(0);
    }, 4000);
    return () => clearTimeout(initial);
  }, []);
  useEffect(() => {
    if (current === 0 && !visible) return;
    const interval = setInterval(() => {
      const next = (current + 1) % SALES.length;
      showNext(next);
    }, 30000);
    return () => clearInterval(interval);
  }, [current, visible]);
  const sale = SALES[current];
  if (!visible) return null;
  return <div className="fixed bottom-6 left-4 z-50 max-w-xs w-full" style={{
    transform: animating ? 'translateY(0)' : 'translateY(20px)',
    opacity: animating ? 1 : 0,
    transition: 'transform 0.4s ease, opacity 0.4s ease'
  }} data-id="element-80">
      <div className="bg-white border border-sage/20 rounded-xl shadow-lg px-4 py-3 flex items-start gap-3" data-id="element-81">
        <div className="flex-shrink-0 mt-0.5 bg-sage/10 rounded-full p-2" data-id="element-82">
          <ShoppingBag className="w-4 h-4 text-sage-dark" data-id="element-83" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-84">
          <p className="text-sm font-bold text-brown font-heading leading-tight" data-id="element-85">
            {sale.name} de {sale.city}
          </p>
          <p className="text-xs text-brown-light font-body mt-0.5" data-id="element-86">
            acaba de comprar el Protocolo
          </p>
          <p className="text-xs text-sage-dark font-bold mt-1" data-id="element-87">{sale.time}</p>
        </div>
        <button onClick={() => {
        setAnimating(false);
        setTimeout(() => setVisible(false), 400);
      }} className="flex-shrink-0 text-brown-light hover:text-brown transition-colors" aria-label="Cerrar" data-id="element-88">
          <X className="w-4 h-4" data-id="element-89" />
        </button>
      </div>
    </div>;
}